"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * State: Versions
 * Fitxer: VersState
 * Autor: Jordi Riu Amblàs
 * Data: 10/04/2018
 * (c) Ajuntament de Manresa - mar 2019 - Departament de Sistemes d'Informació
 */

var mobx_1 = require("mobx");

var VersState =
/** @class */
function () {
  function VersState(appState) {
    this.versions = [];
    this.appState = appState;
    this.lastViewVersion = localStorage.getItem(appState.config.titol + "_lastViewVersion");
  }

  VersState.prototype.load = function () {
    var _this = this;

    if (this.appState.config.showVersions) {
      fetch(process.env.PUBLIC_URL + "/versions.json?t=" + new Date().getTime()).catch().then(function (r) {
        return r.status !== 404 ? r.text() : 'Falta fitxer versions.json o té el format incorrecte';
      }).then(function (versions) {
        try {
          var jVersions = JSON.parse(versions);

          _this.setVersions(jVersions.filter(function (v) {
            return !!v.missatge;
          }));
        } catch (e) {
          _this.setVersions([{
            missatge: versions
          }]);
        }
      });
    }
  };

  VersState.prototype.setVersions = function (versions) {
    this.versions = versions;
  };

  VersState.prototype.viewed = function () {
    if (this.appState.config.showVersions) {
      this.lastViewVersion = this.actualVersion;
      localStorage.setItem(this.appState.config.titol + "_lastViewVersion", this.actualVersion);
    }
  };

  Object.defineProperty(VersState.prototype, "actualVersion", {
    get: function get() {
      return this.appState.config.showVersions ? this.appState.config.subtitol : '';
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(VersState.prototype, "isNewVersion", {
    get: function get() {
      return this.appState.config.showVersions && this.lastViewVersion !== this.actualVersion;
    },
    enumerable: true,
    configurable: true
  });

  __decorate([mobx_1.action], VersState.prototype, "load", null);

  __decorate([mobx_1.observable], VersState.prototype, "versions", void 0);

  __decorate([mobx_1.action], VersState.prototype, "setVersions", null);

  __decorate([mobx_1.observable], VersState.prototype, "lastViewVersion", void 0);

  __decorate([mobx_1.action], VersState.prototype, "viewed", null);

  __decorate([mobx_1.computed], VersState.prototype, "actualVersion", null);

  __decorate([mobx_1.computed], VersState.prototype, "isNewVersion", null);

  return VersState;
}();

exports.default = VersState;